// Dependencies
require("webstrap/normalize");
require("webstrap/print");

// Styles
require("./scaffolding.scss");


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/webstrap/scaffolding/index.js
 ** module id = 12
 ** module chunks = 0 1
 **/